import { render, staticRenderFns } from "./HistoricalImport.vue?vue&type=template&id=1976008c&scoped=true&"
import script from "./HistoricalImport.vue?vue&type=script&lang=js&"
export * from "./HistoricalImport.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalImport.vue?vue&type=style&index=0&id=1976008c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976008c",
  null
  
)

export default component.exports